export default "__VITE_ASSET__ar7twtMk__"